import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';
import {
  ReceiveLoadSubscriptions, RequestLoadSubscriptions, FailLoadSubscriptions,
  RequestSaveSubscriptions, ReceiveSaveSubscriptions, FailSubscriptionsExecute,
  RequestLoadSubscriptionOptions, ReceiveLoadSubscriptionOptions, FailLoadSubscriptionOptions,
  RequestLoadResponsibleForUnit, ReceiveLoadResponsibleForUnit, FailLoadResponsibleForUnit,
  RequestLoadAlerts, ReceiveLoadAlerts, FailLoadAlerts
} from './action-types';
import { api } from './api';
import { ActionDispatching, ComplexValue } from 'app/types-shared';
import { ApplicationState } from 'app/types-store';
import { mapOptionsToStore, mapResponsibleForUnitToStore,
  mapSaveSubscriptions } from 'app/area/user-profile/subscriptions/subscriptions-panel/mappers';
import { replaceSubscriptionError } from 'app/area/user-profile/subscriptions/helpers';

export const actionCreators = {
  loadSubscription: (): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {

      try {
        dispatch(new RequestLoadSubscriptions());

        const result = await api.getSubscription();
        const mapped = mapOptionsToStore(result?.data ?? []);

        dispatch(new ReceiveLoadSubscriptions(mapped));
      } catch (err) {
        err && err.userMessages && dispatch(new ErrorNotification(err.userMessages));
        dispatch(new FailLoadSubscriptions());
      }
    },

  loadSubscriptionOptions: (): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {
      try {
        dispatch(new RequestLoadSubscriptionOptions());

        const result = await api.getSubscriptionOptions();
        const mapped = mapOptionsToStore(result?.data ?? []);

        dispatch(new ReceiveLoadSubscriptionOptions(mapped));
      } catch (err) {
        err && err.userMessages && dispatch(new ErrorNotification(err.userMessages));
        dispatch(new FailLoadSubscriptionOptions());
      }
    },

  saveSubscriptions: (values: ComplexValue<number>[], loadSubscriptionsData: () => void): ActionDispatching<any, any> =>
    async (dispatch: any, getState: () => ApplicationState) => {
      try {
        dispatch(new RequestSaveSubscriptions());

        const mapped = mapSaveSubscriptions(values);
        const result = await api.saveSubscriptions(mapped);

        if (result) {
          dispatch(new ReceiveSaveSubscriptions());
          loadSubscriptionsData();
        }
      } catch (err) {
        dispatch(new FailSubscriptionsExecute());

        const errorText = replaceSubscriptionError(err.userMessages?.[0]?.message, values);
        !!errorText && dispatch(new ErrorNotification(errorText));
        loadSubscriptionsData();
      }
    },

  loadResponsobleForUnit: (): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {

      try {
        dispatch(new RequestLoadResponsibleForUnit());

        const result = await api.getResponsibleForUnit();
        const mapped = mapResponsibleForUnitToStore(result?.data ?? []);

        dispatch(new ReceiveLoadResponsibleForUnit(mapped));

      } catch (err) {
        err && err.userMessages && dispatch(new ErrorNotification(err.userMessages));
        dispatch(new FailLoadResponsibleForUnit());
      }
    },

  loadAlerts: (): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {

      try {
        dispatch(new RequestLoadAlerts());

        const result = await api.getAlerts();
        const mapped = mapOptionsToStore(result?.data ?? []);

        dispatch(new ReceiveLoadAlerts(mapped));

      } catch (err) {
        err && err.userMessages && dispatch(new ErrorNotification(err.userMessages));
        dispatch(new FailLoadAlerts());
      }
    }
};
